import "core-js/modules/es.array.push.js";
import { ref, reactive, toRefs, watchEffect } from "vue";
// import {useStore} from "vuex";
import router from '@/router';
import { useRoute, useRouter } from 'vue-router';
import { getNickNameFromLocalStorage } from '@/util/tool';
import { Bell } from '@element-plus/icons-vue';
import { getSgqfList } from '@/util/request';
import { useStore } from 'vuex';
export default {
  name: "layout",
  setup() {
    const store = useStore();
    const msg_num = ref(store.state.msgNum);
    const route = useRoute();
    const router = useRouter();
    const user = JSON.parse(localStorage.getItem('userInfo'));
    const data = reactive({
      username: user.nickname,
      path: route.path
    });

    // msg_num.value = store.state.msgNum

    //轮询

    let timer = null;
    const setTimer = () => {
      timer = setInterval(() => {
        fetchData();
      }, 100000);
    };
    const fetchData = () => {
      console.log('定时任务');
      const nickname = getNickNameFromLocalStorage();
      const postData = reactive({
        'qishibis': 0,
        'chxunbis': 10,
        'czuoren': nickname
      });
      getSgqfList(postData).then(res => {
        console.log(res);
        if (res.status === 0) {
          // msg_num.value = parseInt(res.data.zongbshu)
          store.dispatch('updateMsgNum', parseInt(res.data.zongbshu));
        } else {}
      }).catch(err => {
        console.log(err);
      });
    };
    fetchData();
    setTimer();

    // 注销用户
    const handleLogout = () => {
      localStorage.clear();

      // store.commit("user/setUserInfo", {});
      console.log('logout');
      router.push({
        path: '/login'
      }).then(() => {}).catch(err => {
        console.log(err);
      });
    };
    //监听路由变化
    router.afterEach(() => {
      // console.log(route.path)
      data.path = route.path;
    });

    //跳转到清分页面
    const gotoQingfen = () => {
      router.push({
        path: '/zjqf/list'
      });
    };
    watchEffect(() => {
      msg_num.value = store.state.msgNum;
    });
    return {
      ...toRefs(data),
      msg_num,
      timer,
      handleLogout,
      gotoQingfen,
      setInterval
    };
  },
  unmounted() {
    console.log('bye');
    clearInterval(this.timer);
    this.timer = null;
  }
};